<template>
	<div id="app" :class="show?'open':''">
		<Header ref="student" :activeIdx="idx"/>
		<router-view ref="tabIdx"/>
		<Footer />
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	export default {
		name: 'App',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				windowWidth: '', //实时屏幕宽度
				show:false,//侧边栏是否打开
				idx:0
			}
		},
		watch: {
			windowWidth: {
				handler(e) {
				},
				deep: true
			}
		},
		mounted() {
			 
			window.onresize = () => {
				this.windowWidth = document.body.clientWidth
			}
		},
		methods: {
			getIdx(e){
				this.idx = Number(e);
				console.log(e,'组件');
			},
			getShow(e){
				this.show = e
			}
		}
	}
</script>

<style>
	body {
		margin: 0;
		line-height: 1;
	}

	#app {
		font-family: Microsoft YaHei;
		color: #000;
		font-size: 14px;
		box-sizing: border-box;
	}

	p {
		margin: 0;
	}

	a {
		color: #000;
		text-decoration: none;
	}

	.line26 {
		line-height: 26px;
	}
	.line40 {
		line-height: 40px;
	}
	.w1200 {
		width: 1200px;
		margin: 0 auto;
	}

	.bg02 {
		background: #020303;
	}

	.bg16 {
		background: #161916;
	}
	.bg-e6{
		background: #e6e6e6;
	}
	.cor-f {
		color: #fff;
	}
	.cor-66 {
		color: #666;
	}
	.cor-8f {
		color: #8FC31F;
	}
	.cor-d {
		color: #a8a8a8;
	}
	.cor-59 {
		color: #595757;
	}
	.cor-00 {
		color: #000;
	}
	.cor-27 {
		color: #004727 !important;
	}

	.cor-8d {
		color: #8dc21f;
	}
	.cor-f7 {
		color: #F7AB00;
	}
	.cor-f5 {
		color: #F5A200;
	}
	.opty5 {
		opacity: .5;
	}

	.relative {
		position: relative;
	}

	.flex {
		display: flex;
	}

	.align-items {
		align-items: center;
	}

	.just-center {
		justify-content: center;
	}

	.just-around {
		justify-content: space-around;
	}

	.just-between {
		justify-content: space-between;
	}

	.center {
		text-align: center;
		display: block;
	}
	.let-spc6{
		letter-spacing: 6px;
	}
	.let-spc12{
		letter-spacing: 12px;
	}
	.text-index2{
		text-indent: 30px;
	}
	.fw {
		font-weight: bold;
	}
	.fs10 {
		font-size: 10px;
	}
	.fs12 {
		font-size: 12px;
	}

	.fs14 {
		font-size: 14px;
	}

	.fs16 {
		font-size: 16px;
	}

	.fs18 {
		font-size: 18px;
	}

	.fs20 {
		font-size: 20px;
	}

	.fs22 {
		font-size: 22px;
	}

	.fs24 {
		font-size: 24px;
	}

	.fs26 {
		font-size: 26px;
	}
	.fs28 {
		font-size: 28px;
	}
	.fs34 {
		font-size: 34px;
	}
	.fs36 {
		font-size: 36px;
	}
	.fs42 {
		font-size: 48px;
	}
	.fs45 {
		font-size: 45px;
	}
	.fs48 {
		font-size: 42px;
	}

	.fs60 {
		font-size: 60px;
	}

	.fs30 {
		font-size: 30px;
	}
	.fs32 {
		font-size: 32px;
	}
	.fs39 {
		font-size: 39px;
	}
	.mb70 {
		margin-bottom: 70px;
	}

	.mt46 {
		margin-top: 46px;
	}

	.mt30 {
		margin-bottom: 30px;
	}

	.mt20 {
		margin-bottom: 20px;
	}

	.mg20 {
		margin: 20px 0;
	}

	.mr10 {
		margin: 10px 0;
	}
	.mt10{
		margin-bottom: 10px;
	}
	.ml30 {
		margin-left: 30px;
	}
	.mt14{
		margin-top: 14px;
	}

	.pr30 {
		padding-right: 30px;
	}

	.pt40 {
		padding-top: 40px;
	}

	.pb30 {
		padding-bottom: 30px;
	}

	.p12 {
		padding: 12px 0;
	}

	.ov2 {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	#app{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		/* height: 100vh; */
	}
	/* #app.open{
		overflow: hidden;
	} */
</style>
